var path = 'src/app/components/common/form-section/form-section.template.html';
var html = "<div class=\"form-section\">\n\t<h3 class=\"form-section__title\" ng-if=\"$ctrl.formTitle\">{{$ctrl.formTitle}}</h3>\n\t<div class=\"form-section__fields\" ng-transclude>\n\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;